export const GENDERS = ['männlich', 'weiblich', 'divers'] as const;
export type Gender = typeof GENDERS[number];

export const AGE_RANGES = ['jung', 'mittel', 'älter'] as const;
export type AgeRange = typeof AGE_RANGES[number];

export const LANGUAGES = [
  'Deutsch',
  'Englisch',
  'Französisch',
  'Italienisch',
  'Niederländisch',
  'Polnisch',
  'Spanisch',
  'Tschechisch',
  'Türkisch',
  'Ungarisch',
  'weitere Sprachen',
] as const;
export type Language = typeof LANGUAGES[number];

export const USE_CASES = [
  'Werbung',
  'Hörbuch',
  'Erklärvideo',
  'E-Learning',
  'Kinderprogramm',
  'Dokumentation',
  'Voicemail',
] as const;
export type UseCase = typeof USE_CASES[number];

export const CHARACTERS = [
  'warm',
  'seriös',
  'freundlich',
  'energisch',
  'ruhig',
  'sportlich',
  'elegant',
  'rau',
  'markant',
  'jugendlich',
  'väterlich',
  'mütterlich',
] as const;
export type Character = typeof CHARACTERS[number];

export const TONALITIES = ['professionell', 'casual', 'emotional', 'sachlich'] as const;
export type Tonality = typeof TONALITIES[number];

// Scoring-Gewichte fuer den Matching-Algorithmus.
// Sprache ist bewusst Soft-Filter (Bonus), nicht Hard-Filter, weil ElevenLabs-
// Voices prinzipiell auch Sprachen generieren koennen, fuer die sie nicht
// explizit gelabelt sind. Fehlende Sprache fliegt also nicht raus, bekommt
// nur keinen Language-Bonus beim Ranking.
export const MATCH_WEIGHTS = {
  useCases: 3,
  languages: 2,
  characters: 2,
  tonality: 2,
  ageRange: 1,
} as const;

export const MAX_VOICE_SELECTION = 3;
export const TOP_RESULTS_COUNT = 7;
